// extracted by mini-css-extract-plugin
export var bottomText = "SectionTable-module--bottomText--28de8";
export var card = "SectionTable-module--card--77197";
export var tableWrapper = "SectionTable-module--tableWrapper--14bbc";
export var topText = "SectionTable-module--topText--13450";